import { createTheme, CssBaseline, ThemeProvider, useMediaQuery } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { HelmetProvider } from "react-helmet-async";

import { CourseProvider } from "../../context/course-context";
import { HasbotProvider } from "../../context/hasBot-context";
import { LocalizationProvider, SupportedLocales } from "../../context/localization-context";
import { usePersistedSettings } from "../../hooks/usePersistedSettings";
import * as locales from "../../locale/index";
import customTheme from "../../styles/theme";
import { TelemetryLayer } from "../../telemetry/TelemetryLayer";
import { ProgressModal } from "../Progress/ProgressModal";

const PlayerWrapper: React.FC = ({ children }) => {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const [locale, setLocale] = useState<SupportedLocales>("enUS");
  const { mode, setMode } = usePersistedSettings();

  const preferredMode = prefersDarkMode ? "dark" : "light";

  const theme = useMemo(
    () => createTheme(customTheme(mode || preferredMode), locales[locale]),
    [locale, mode, preferredMode],
  );

  useEffect(() => {
    if (!mode) {
      setMode(preferredMode);
    }
  }, [mode, preferredMode, setMode]);

  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LocalizationProvider value={{ locale, setLocale }}>
          <TelemetryLayer>
            <ProgressModal />
            <CourseProvider>
              <HasbotProvider>{children}</HasbotProvider>
            </CourseProvider>
          </TelemetryLayer>
        </LocalizationProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
};

export default PlayerWrapper;
